module.exports = __webpack_public_path__ + "static/media/14UNEP22.131fd883.jpg";